import { PresentationSettings, InteractionMode } from 'messages/websocket.messages';

import { InteractionModePresets } from '../../social-state-machine/social-state.constants';

const { ALL_HANDS, CLASSROOM, GROUP_ACTIVITY, NO_AUDIENCE_PARTICIPATION, OPEN_AUDIENCE_PARTICIPATION, SPEECH_MODE } =
  InteractionModePresets;

export const AUDIO_PRESET_BUTTONS: AudioPresetButtonConfig[] = [
  {
    icon: '/assets/images/Unmuted.svg',
    text: 'Speech',
    audioMode: SPEECH_MODE,
  },
  {
    icon: '/assets/images/all_hands.svg',
    text: 'All Hands',
    audioMode: ALL_HANDS,
  },
  {
    icon: '/assets/images/question_answer.svg',
    text: 'Open',
    audioMode: OPEN_AUDIENCE_PARTICIPATION,
  },
  {
    icon: '/assets/images/theater_comedy.svg',
    text: 'Group Activity',
    audioMode: GROUP_ACTIVITY,
  },
  {
    icon: '/assets/images/question_answer.svg',
    text: 'Classroom',
    audioMode: CLASSROOM,
  },
  {
    icon: '/assets/images/plus&minus.svg',
    text: 'Restricted',
    audioMode: NO_AUDIENCE_PARTICIPATION,
  },
];

export interface AudioPresetButtonConfig {
  icon: string;
  text: string;
  audioMode: PresentationSettings;
}

export interface InteractionModeDescription {
  value: InteractionMode;
  label: string;
  tooltip: string;
}
